// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addressBookInputType{padding-left:5px;height:30px;border:1px solid #ccc;border-radius:5px;cursor:text;width:calc(100% - 100px);background:#fff!important;float:left}.addressBookInputType::-moz-placeholder{color:#bdbdbd}.addressBookInputType::placeholder{color:#bdbdbd}.addressItemWrite{display:flex;align-items:center;min-height:65px}", ""]);
// Exports
module.exports = exports;
